import moment from "moment";

function Chores() {
  const url = window.location.href;

  var regex = /[?&]([^=#]+)=([^&#]*)/g,
    params = {},
    match;
  while ((match = regex.exec(url))) {
    params[match[1]] = match[2];
  }

  const safeYear = params.date.split("-")[0];
  let safeMonth = params.date.split("-")[1];
  if (safeMonth.length === 1) {
    safeMonth = "0" + safeMonth;
  }

  const startOfYear = moment(safeYear + "-" + safeMonth + "-01")
    .set("month", 0)
    .startOf("isoWeek");

  const colocs = params.colocs
    .split(";")
    .map(
      (c) => c.toLowerCase()[0].toUpperCase() + c.toLowerCase().substring(1)
    );

  return (
    <div>
      <div
        style={{ fontWeight: "bold", marginBottom: "30px", marginTop: "20px" }}
      >
        MERCREDI : CUISINE
        <br />
        JEUDI : POUBELLES
        <br />
        WEEKEND : GROS CLEANING
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "column",
          height: "860px",
          width: "700px",
          border: "0px solid black",
        }}
      >
        {new Array(53).fill({}).map((o, index) => {
          const renderDate = startOfYear.clone();
          startOfYear.add(7, "days");
          return (
            <div style={{ width: "300px" }}>
              {(renderDate.clone().format("MM") !==
                renderDate.clone().add(6, "days").format("MM") ||
                renderDate.clone().format("DD") === "01") && (
                <div style={{ fontWeight: "bold", margin: "30px 0px 5px 0px" }}>
                  {renderDate
                    .clone()
                    .add(
                      renderDate.clone().format("DD") === "01" ? 0 : 1,
                      "month"
                    )
                    .format("MMMM YYYY")
                    .toUpperCase()}
                </div>
              )}
              <div>
                {`${renderDate.format("DD / MM")} → ${renderDate
                  .clone()
                  .add(6, "days")
                  .format("DD / MM")} : ${colocs[index % colocs.length]}`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Chores;
